import { forwardRef, Ref } from 'react';
import { useIntl } from 'react-intl';
import { Datepicker, InputField } from '@ets/design-system';

type DueDateFieldProps = {
  id?: string;
  dueDate?: Date | null;
  onChange: (newValue: Date | null) => void;
  testId: string;
};

const DueDateField = forwardRef(
  ({ id, dueDate, onChange, testId }: DueDateFieldProps, ref: Ref<HTMLDivElement>) => {
    const intl = useIntl();

    const currentDate = new Date();

    return (
      <InputField
        size="m"
        label={intl.formatMessage({ id: 'settings.general.dueDate' })}
        renderFeedbackIfEmpty={false}
        style={{ margin: '2rem 0 0 0' }}
        testId={`${testId}-due-date`}
      >
        <div ref={ref} id={id}>
          <Datepicker
            dateFilter={[
              {
                dateFilterType: 'after',
                dateFilter: new Date(currentDate.setDate(currentDate.getDate() - 1)),
              },
            ]}
            size="m"
            selected={dueDate ?? null}
            onChange={onChange}
            testId={`${testId}-due-date`}
          />
        </div>
      </InputField>
    );
  },
);

export default DueDateField;
